import {  
    // getFirestore,
    // doc,
    // setDoc,
} from "firebase/firestore";
import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const scriptForUpdateGroupId = async function() {
    const run = 0;

    // let db = getFirestore();
    const app = firebase.app();
    const functions = getFunctions(app, 'asia-east2');
    const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');
    let query = `
    select
        G.groupId
    from
        thaisook_view.groups G
    `;

    if( run ){

        const result = await queryThaisookViewBigQuery({
            info: 'get group list',
            query: query 
        });
        const resultObj = JSON.parse(result.data);
        console.log('=== > Start update ' , resultObj.length);

        let firestore = firebase.firestore();
        let batch = firestore.batch();
        const batchSize = 500;
        let batchSet = 0;
        let batchSetTotal = 0;
        if( resultObj.length ){
            for (let i = 0; i < resultObj.length; i++) {
                const item = resultObj[i];
                if( item['groupId'] ){
                    const groupData = firestore.collection("wellness_groups").doc(item['groupId']);
                    batch.set(groupData, {groupId: item['groupId']}, { merge: true }); // Here, the update will be added to the batch, but won't be executed now 
                    ++batchSet;
                    ++batchSetTotal;
                    if( batchSet == batchSize){
                        console.log('batchCommit', batchSetTotal);
                        await batch.commit();
    
                        batch = firestore.batch();
                        batchSet = 0;
                    }
                }
            }
            // Push the remaining data into Firestore
            console.log('batchCommit last', batchSet);
            await batch.commit();
        }
        console.log('Done');
    }
    else{
        console.log('Run is zero');
    }
};
export default scriptForUpdateGroupId;